import React, { useState,useEffect } from "react";
import styled from "styled-components";
import Slider from "../../components/Slider/Slider";
import Spinner from "../../components/Spinner/Spinner";
import GameCollection from "../../components/GameCollection/GameCollection";
import gameConfig from "../../utils/gamesConfig";
import { useTranslation } from "react-i18next";


const Home = ({ props }) => {
  //const { state } = React.useContext(userContext);
  const { videos, category } = gameConfig;
  const [ games, setGames ] = useState(null);
  const { t } = useTranslation("global"); 
  const sliders=[{"id":1,"name":"s1","imageUrl":"/images/s1.png"},{"id":2,"name":"s2","imageUrl":"/images/s2.png"},{"id":3,"name":"s3","imageUrl":"/images/s3.png"},{"id":4,"name":"s4","imageUrl":"/images/s4.png"}]

   useEffect(() => {
    setGames(videos);
   /*setGames( videos.filter((item) => (
        item.category === "Stroy" || item.category === "Rhymes" || item.category === "Learning"
      )));*/
    },[videos!=null]);

  return (
    (videos!=null && games!=null )? 
      <HomeStyled> 
          <br/>
          <p>{t("portalText.desc")}</p>
          {/* <Slider games={games.sort(() => Math.random() - Math.random()).slice(0, 5)} /> */}
          <Slider games={sliders.sort(() => Math.random() - Math.random()).slice(0, 5)} />
          <GameCollection
            category={category}
            games={videos}
            msisdn={""}
          /> 
       </HomeStyled>
    :<Spinner />   
  );
};

export default Home;

const LoaderStyled = styled.div`
  position: absolute;
  top: 0;
  background-image: linear-gradient(to right, #c0392b, #8e44ad);
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const HomeStyled = styled.div`
  /* background-image: linear-gradient(to right, #434343 0%, black 100%); */
  h1 {
    color: #fff;
    text-align: center;
      font-weight: 400;
      background-image: linear-gradient(to right, #0099f7, #f11712);
      padding: 5px;
      border-radius: 5px;
      box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px,
        rgba(0, 0, 0, 0.3) 0px 30px 60px -30px,
        rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;
    }
    background-image: linear-gradient(to right, #c0392b, #8e44ad);
  .section-collection {
    /* padding: 20px; */
    /* width: 80%; */
    
    h3 {
      color: black;
      font-weight: 400;
      /* background-image: linear-gradient(to right, #0099f7, #f11712); */
      padding: 5px;
      border-radius: 5px;
      margin-left: 10px;
      box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px,
        rgba(0, 0, 0, 0.3) 0px 30px 60px -30px,
        rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;
    }
   
  }
     p {
      color: white;
      font-weight: bold;
      text-align: center;
      margin:10px;
      font-size:16px;
    }

  .game-collection {
    display: flex;
    flex-wrap: wrap;

    /* justify-content: space-between; */

    .card-item {
      cursor: pointer;
      position: relative;
      /* min-height: 16vh; */
      flex: 0 0 44%;
      max-width: 100%;
      /* padding: 0 10px; */
      margin: 10px 0px;
      margin: 10px;
      overflow: hidden;
      transition: all 0.5s ease-in-out;
      border-radius: 10px;
      width: 100%;
      box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
        rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
        rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
      transition: 1s ease;

      :hover {
        -webkit-transform: scale(0.9);
        -ms-transform: scale(0.9);
        transform: scale(0.9);
        transition: 1s ease;
      }

      .overlay-buttons {
        position: absolute;
        background-color: rgba(1, 1, 1, 0.2);
        width: 100%;
        height: 100%;
        z-index: 1;
        opacity: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        .box {
          background: linear-gradient(to right, gold, darkorange);
          color: white;
          --width: 120px;
          --height: calc(var(--width) / 3);
          width: var(--width);
          height: var(--height);
          text-align: center;
          line-height: var(--height);
          font-size: calc(var(--height) / 2.5);
          font-family: sans-serif;
          letter-spacing: 0.2em;
          border: 1px solid darkgoldenrod;
          border-radius: 2em;
          transform: perspective(500px) rotateY(-15deg);
          text-shadow: 6px 3px 2px rgba(0, 0, 0, 0.2);
          box-shadow: 2px 0 0 5px rgba(0, 0, 0, 0.2);
          transition: 0.5s;
          position: relative;
          overflow: hidden;
        }

        .box:hover {
          transform: perspective(500px) rotateY(15deg);
          text-shadow: -6px 3px 2px rgba(0, 0, 0, 0.2);
          box-shadow: -2px 0 0 5px rgba(0, 0, 0, 0.2);
        }

        .box::before {
          content: "";
          position: absolute;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            to right,
            transparent,
            white,
            transparent
          );
          left: -100%;
          transition: 0.5s;
        }

        .box:hover::before {
          left: 100%;
        }
        /* display: none; */

        :hover {
          opacity: 1;
        }
      }
      img {
        z-index: 2;
        /* border-radius: 10px !important; */
        mix-blend-mode: unset !important;
        height: 137px !important;
        width: 100%;
        max-height: 100%;
        /* object-fit: cover; */
        display: inline-block;
        vertical-align: middle;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        -webkit-filter: brightness(90%);
        -webkit-transition: all 1s ease;
        -moz-transition: all 1s ease;
        -o-transition: all 1s ease;
        -ms-transition: all 1s ease;
        transition: all 1s ease;

        /* object-position: center; */
      }
      @media (min-width: 768px) {
        flex: 0 0 22%;
        img {
          height: 200px !important ;
        }
      }
    }
  }
`;
